import {IGraphMythNFTType} from "./ResponseBean";
import {getMythNFTSConfig, IMythNFTConfig} from "../env";
import {getNFTImage} from "../constant/CommonConstant";
import {MythNFTRarity} from "../constant/MythRarity";


export interface IMythNFTType {
    nftTypeId: number,
    name: string,
    image: string,
    rarity:MythNFTRarity
}

export interface ICompilationItem {
    mythNFTType: IMythNFTType;
    collected: boolean;
}

export interface ICompilationRequestParams {
    mythNFTTypes: IMythNFTType[];
    nftTypeIds: number[]
}

export function convertToCompilationItems(graphMythNFTTypes: IGraphMythNFTType[] | undefined, mythNFTTypes: IMythNFTType[]): ICompilationItem[] {
    const compilationItems: ICompilationItem[] = [];
    if (mythNFTTypes && mythNFTTypes.length > 0) {
        mythNFTTypes.forEach(value => {
            const collected: boolean = !!graphMythNFTTypes && graphMythNFTTypes.findIndex((item, index) => {
                return item.nftTypeId === value.nftTypeId;
            }) !== -1;
            const compilationItem: ICompilationItem = {
                mythNFTType: value,
                collected: collected,
            };
            compilationItems.push(compilationItem);
        });
    }
    return compilationItems;
}

export function getCompilationRequestParams(contractAddr: string, first: number, skip: number,rarity:MythNFTRarity): ICompilationRequestParams {
    const mythNFTSConfig: IMythNFTConfig[] = getMythNFTSConfig();
    const mythNFTConfig = mythNFTSConfig.find(value => {
        return value.theme.contractAddr.toLowerCase() === contractAddr.toLowerCase()
    });
    const mythNFTTypes: IMythNFTType[] = [];
    const nftTypeIds: number[] = [];
    if (mythNFTConfig && mythNFTConfig.metadata && mythNFTConfig.metadata.length > skip) {
        for (let i = skip; i < mythNFTConfig.metadata.length; i++) {
            const mythNFTMetadata = mythNFTConfig.metadata[i];
            if(rarity === MythNFTRarity.ALL || rarity === mythNFTMetadata.rarity){
                const mythNFTType = {
                    nftTypeId: mythNFTMetadata.nftTypeId,
                    name: mythNFTMetadata.name,
                    image: getNFTImage(mythNFTConfig.theme.imageDir,mythNFTMetadata.nftTypeId),
                    rarity:mythNFTMetadata.rarity
                };
                mythNFTTypes.push(mythNFTType);
                nftTypeIds.push(mythNFTMetadata.nftTypeId);
            }
        }
    }
    return {mythNFTTypes: mythNFTTypes, nftTypeIds: nftTypeIds};
}
